import React, { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { loadingState } from "src/atom/LoadingState";
import {
  downloadChildFile,
  downloadParentFile,
} from "src/services/MainPage/GenericService";
import { handleDownload } from "src/utils";

const ImagePreview = ({ previewLabel, parentQuestion, data, isChild }) => {
  const [showPreview, setshowPreview] = useState(false);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [previewFile, setPreviewFile] = useState("");
  const [imageText, setImageText] = useState("Loading Image...");
  const enableLoader = useSetRecoilState(loadingState);

  const downloadClick = () => {
    if (isChild) {
      enableLoader(true);
      downloadChildFile(data, parentQuestion?.id).then((response) => {
        enableLoader(false);
        if (response.success == true) {
          handleDownload(response.body.fileContent, response.body.fileName);
        } else {
        }
      });
    } else {
      enableLoader(true);
      downloadParentFile(
        parentQuestion.milestoneId,
        data,
        parentQuestion?.id
      ).then((response) => {
        enableLoader(false);
        if (response.success == true) {
          handleDownload(response.body.fileContent, response.body.fileName);
        } else {
        }
      });
    }
  };

  useEffect(() => {
    if (data != undefined && parentQuestion != undefined) {
      setIsDataAvailable(true);
      setshowPreview(parentQuestion.preview);
      if (parentQuestion.preview == true) {
        if (isChild) {
          downloadChildFile(data, parentQuestion?.id).then((response) => {
            if (response.success == true) {
              setPreviewFile(response.body?.fileContent);
              setImageText("");
            } else {
              setImageText("Can't load image");
            }
          });
        } else {
          downloadParentFile(
            parentQuestion.milestoneId,
            data,
            parentQuestion?.id
          ).then((response) => {
            if (response.success == true) {
              setPreviewFile(response.body?.fileContent);
              setImageText("");
            } else {
              setImageText("Can't load image");
            }
          });
        }
      }
    } else {
      setIsDataAvailable(false);
      setshowPreview(false);
    }
  }, [data, parentQuestion]);
 
  return (
    <>
      {showPreview && isDataAvailable && previewFile !== "" && (
        <img src={`data:image/png;base64, ${previewFile}`} alt="Base64 Image" />
      )}
      {showPreview && previewFile === "" && <p>{imageText}</p>}
      {!showPreview && isDataAvailable && (
        <button
          type="button"
          className="btn btn-sm btn-link"
          style={{ fontSize: "15px", textDecoration: "none" }}
          onClick={downloadClick}
        >
          {previewLabel ? previewLabel : "Download Your Uploaded File"}
        </button>
      )}
    </>
  );
};

export default ImagePreview;
